import { defineComponent as _defineComponent } from 'vue'
import DealsApi from '@/modules/deals/services/DealsApi';
import {DealStatus} from '@/modules/deals/enums/DealStatus';
import Deal from '@/models/Deal';
import {getDictionaryByEnumObject} from '@/services/enumTranslator/GetDictionaryByEnumObject';
import EnvironmentService from '@/env/EnvironmentService';
import {computed} from 'vue';
import {editableStatuses} from '@/modules/deals/enums/editableStatuses';


export default /*#__PURE__*/_defineComponent({
  __name: 'DealChip',
  props: {
    deal: null,
    disabled: { type: Boolean },
    showDealStage: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  deal: Deal;
  disabled?: boolean;
  showDealStage?: boolean;
}



const stages = getDictionaryByEnumObject<DealStatus>(JSON.parse(JSON.stringify(DealStatus)), 'DealStatus')
  ?.filter(item => {
    return !EnvironmentService.Environment.isAppDomain().NESTO_RO || item.type !== DealStatus.RETURNED_TO_AGENT_CC;
  });
const updateStatus = async(statusType: DealStatus) => {
  props.deal.status = statusType;
  await DealsApi.updateDealStatus(props.deal.id, statusType);
};

const isDealEditable = computed<boolean>(() => {
  return !props.disabled && props.deal.userCanEdit.STATUS;
});

const canEditStatus = (stageType: DealStatus): boolean => {
  const newStageIndex = stages.findIndex(item => item.type === stageType);
  const oldStageIndex = stages.findIndex(item => item.type === props.deal.status);
  return newStageIndex <= oldStageIndex;
};

const getStatuses = computed(() => {
  return stages?.filter(x => editableStatuses(props.deal.productType!).includes(x.type));
});

return { __sfc: true,props, stages, updateStatus, isDealEditable, canEditStatus, getStatuses, DealStatus }
}

})